import { render, staticRenderFns } from "./speaker-queue-list-component.vue?vue&type=template&id=48d52fe0&scoped=true"
import script from "./speaker-queue-list-component.ts?vue&type=script&lang=ts&external"
export * from "./speaker-queue-list-component.ts?vue&type=script&lang=ts&external"
import style0 from "./speaker-queue-list-component.scss?vue&type=style&index=0&id=48d52fe0&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d52fe0",
  null
  
)

export default component.exports